import React, { useRef, useEffect } from 'react';
import _ from 'underscore';

export default function ToggleSwitch({
  on, label, onChange, disabled, disabledTitle, id
}) {
  const inputContainer = useRef();
  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  const inputId = id || `toggle_switch_${_.uniqueId()}`;

  useEffect(() => {
    $(inputContainer.current).on('change', handleChange);
  }, []);

  useEffect(() => {
    $(inputContainer.current).prop('checked', on).prop('disabled', disabled);
    if (disabled && disabledTitle) {
      $(inputContainer.current).attr('title', disabledTitle);
    } else {
      $(inputContainer.current).removeAttr('title');
    }
  }, [disabled, on, disabledTitle]);

  return (
    <label className="ToggleSwitch ToggleSwitch--primary bottom-buffer-none-lg" htmlFor={inputId}>
      <input type="checkbox" defaultChecked={on} ref={inputContainer} defaultValue="on" id={inputId} />
      {label}
    </label>
  );
}
